exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".teams-box--name {\n  font-weight: 100;\n}\n.teams-box--title {\n  font-size: 22px;\n  color: #f5f5f5;\n  margin-bottom: 2px;\n}\n.vuecal__no-event {\n  padding: 2px;\n}", ""]);

// exports
